var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoBlue = function SvgLogoBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#001D52",
    rx: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.365 23.5H9.219l-.125.636c-.042.229.02.468.166.645a.8.8 0 0 0 .605.282h2.385a3.45 3.45 0 0 1 .115-1.563M23.49 12.854a.76.76 0 0 0-.605-.291H11.948a.79.79 0 0 0-.77.635l-.074.406h2.406c1 0 1.823.823 1.823 1.823a1.83 1.83 0 0 1-.896 1.563c.532.323.896.896.896 1.562a1.83 1.83 0 0 1-.896 1.563c.323.198.584.49.74.843a3.65 3.65 0 0 1 4.323 3.584c0 .177-.01.354-.042.52h1.084a.78.78 0 0 0 .76-.614l2.344-10.937a.75.75 0 0 0-.156-.657m3.562 2.834h-2.23a.79.79 0 0 0-.77.614l-1.667 7.813c-.052.229 0 .468.157.656a.76.76 0 0 0 .604.291h.562a3 3 0 0 1-.041-.52 3.65 3.65 0 0 1 3.645-3.646 3.65 3.65 0 0 1 3.646 3.646c0 .114 0 .218-.02.333a.68.68 0 0 0 .26-.427l.781-3.646a1 1 0 0 0 .021-.166 4.95 4.95 0 0 0-4.948-4.948"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC075",
    d: "M13.51 16.208H9.865a.781.781 0 0 1 0-1.562h3.645a.781.781 0 1 1 0 1.562m0 3.125H8.823a.781.781 0 0 1 0-1.562h4.687a.781.781 0 1 1 0 1.562m0 3.125H7.781a.781.781 0 0 1 0-1.562h5.73a.781.781 0 1 1 0 1.562"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.854 27.146a2.607 2.607 0 0 1-2.604-2.604 2.607 2.607 0 0 1 2.604-2.605 2.607 2.607 0 0 1 2.604 2.605 2.607 2.607 0 0 1-2.604 2.604M24.708 24.542a2.607 2.607 0 0 0 2.605 2.604 2.607 2.607 0 0 0 2.604-2.604 2.607 2.607 0 0 0-2.605-2.605 2.607 2.607 0 0 0-2.604 2.605"
  })));
};
export default SvgLogoBlue;